import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Activity, Calendar, Shield, Award } from 'lucide-react';
export function Deliverables() {
  const items = [{
    icon: <BookOpen size={24} data-id="element-90" />,
    title: 'La Guía Maestra "Reset de Energía 21 Días" (PDF)',
    desc: 'El manual paso a paso para saturar tus reservas.'
  }, {
    icon: <Activity size={24} data-id="element-91" />,
    title: 'El Test de Señales de Brecha',
    desc: 'Identifica en 2 minutos qué nutriente exacto le falta a tu cerebro hoy.'
  }, {
    icon: <Calendar size={24} data-id="element-92" />,
    title: 'Plan de Suplementación Estratégica',
    desc: 'Cuándo y cómo tomar cada apoyo para que tu cuerpo realmente lo absorba.'
  }, {
    icon: <Shield size={24} data-id="element-93" />,
    title: 'Lista de "Alimentos Escudo"',
    desc: 'Los 12 ingredientes que protegen tus niveles de energía durante semanas de estrés.'
  }, {
    icon: <Award size={24} data-id="element-94" />,
    title: 'Bono: Guía de Selección de Soporte',
    desc: 'Qué buscar en una etiqueta para no tirar tu dinero.'
  }];
  return <section className="py-24 px-4 bg-offwhite" data-id="element-95">
      <div className="max-w-4xl mx-auto" data-id="element-96">
        <FadeIn data-id="element-97">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-forest mb-12 text-center" data-id="element-98">
            Lo que obtienes hoy
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-99">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-100">
              <div className="bg-white p-6 rounded-xl shadow-sm border border-sage/60 flex items-start gap-6 hover:shadow-md transition-shadow" data-id="element-101">
                <div className="w-12 h-12 bg-amber/20 rounded-lg flex items-center justify-center shrink-0 text-amber-hover" data-id="element-102">
                  {item.icon}
                </div>
                <div data-id="element-103">
                  <h3 className="font-bold text-lg text-forest mb-1" data-id="element-104">
                    {item.title}
                  </h3>
                  <p className="text-charcoal/70" data-id="element-105">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}